define('views/modules/setting/business/payment/payment-safety-notice',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'bootbox', 'utils',
    'services/i18n',
    // views
    'views/parts/info-section',
    // templates
    'text!templates/modules/setting/business/payment/payment-safety-notice.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, Bootbox, U, i18n,
    // views
    VInfoSection,
    // templates
    TPaymentSafetyNotice
) {

    var VPaymentSafetyNotice = Backbone.Epoxy.View.extend({
        template: TPaymentSafetyNotice,

        initialize: function(opt) {
            this.options = opt = opt || {};

            this.view = {
                info: new VInfoSection({
                    hideTitleSection: true,
                })
            };
        },

        render: function(hiddenDelay) {
            var view = this.view,
                html = Mustache.render(this.template, Mustache.getContext());

            this.assign(view.info, this.$el) // must be first
                .generateZones();

            view.info.setContent(html);

            this.applyBindings();

            return this;
        },

        toggleDisplay: function(isCreditCardPayment) {
            this.$el.toggleClass('hidden', !isCreditCardPayment);
        },
    });

    return VPaymentSafetyNotice;
});

